import React from "react";

const shops = [
  { id: 1, name: "Opticon Framing", address: "16 Milne Street, Thomastown, Victoria 3074" },
  { id: 2, name: "The Frame Shop Moonee Ponds", address: "131 Puckle St, Moonee Ponds, Victoria 3039" },
  { id: 3, name: "Eltham Picture Framing", address: "Shop 19-20, Eltham Town Mall 10-18 Arthur St Eltham, Victoria <br>3095" },
  { id: 4, name: "The Presentation Place", address: "20 Ferguson Street, Williamstown VIC 3016" },
];

export default function ShopSelectPopup({ onSelectShop }) {
  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <h2>Select a Shop</h2>
        <div className="shop-cards">
          {shops.map((shop) => (
            <div
              key={shop.id}
              className="shop-card"
              onClick={() => onSelectShop(shop.name)}
            >
              <h3>{shop.name}</h3>
              <p className="shop-address">
                {shop.address.split("<br>").map((line, i) => (
                  <React.Fragment key={i}>
                    {line.trim()}
                    <br />
                  </React.Fragment>
                ))}
              </p>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
